module.exports = __webpack_public_path__ + "static/popmenu2-8d0de8b2525cad05bcd25363361efb6f.png";